import React from "react";

import ContentCore from "../../../core/workingContent";

import "../_index.css";

const TaskNeedToGive = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskNeedToGive;
